import { useCallback } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

import CompanySpecificSkillLogo from '../../../../components/CompanySpecificSkillLogo/CompanySpecificSkillLogo';
import styles from './SelectedSkills.styles';
import classnames from 'classnames';
import { Skill } from 'GQL/graphql.ts';
import get from 'lodash/get';

const useStyles = makeStyles(styles);

interface SelectedSkillsProps {
  withInteractiveSkills?: boolean;
  isEditMode?: boolean;
  skills: Array<Skill>;
  onClick?: (skillId: string) => void;
  disabled?: boolean;
}

const SelectedSkills = ({
  withInteractiveSkills = true,
  isEditMode = false,
  skills,
  onClick = null,
  disabled = false,
}: SelectedSkillsProps) => {
  const classes = useStyles();

  const replaceDefaultLogo = get(window.PALYX_WHITE_LABEL, 'skillButton.replaceDefaultLogo', false);

  const onClickCallback = useCallback(
    (clickedSkillId: string) => {
      if (isEditMode && onClick) {
        onClick(clickedSkillId);
      }
    },
    [onClick, isEditMode]
  );

  return (
    <div
      className={classnames(skills?.length ? classes.skillsWrapper : null, {
        [classes.noEventsAllowed]: !withInteractiveSkills,
      })}
      data-test="selected-skills-part"
    >
      {skills?.map(skill => (
        <Button
          sx={{
            wordBreak: 'break-word',
          }}
          key={skill._id}
          variant="contained"
          className={classes.selectedSkill}
          onClick={() => onClickCallback(skill._id)}
          disabled={disabled}
          data-test="skill-button"
        >
          {skill.synonym?.companySpecific?.isLogoVisible && (
            // @ts-ignore
            // TODO: Refactor companySpecificSkillLogo to into TS
            <CompanySpecificSkillLogo height={20} replaceDefaultLogo={replaceDefaultLogo} />
          )}
          {skill.synonym?.synonymString}
          {withInteractiveSkills && <ClearIcon className={classes.selectIcon} />}
        </Button>
      ))}
    </div>
  );
};

export default SelectedSkills;
